import { useEffect, useState } from 'react';
import { api, type Me } from './api';

/**
 * One `/me` request for the whole app.
 *
 * The account menu and the instance picker both need the caller's organization
 * and they mount together, so the promise is cached at module scope: the second
 * consumer joins the first request rather than issuing its own.
 */
let pending: Promise<Me | null> | null = null;

function loadMe(): Promise<Me | null> {
  pending ??= api.me().catch(() => {
    // Don't cache a failure as a permanent null — the next mount should retry.
    pending = null;
    return null;
  });
  return pending;
}

export function useMe(): Me | null {
  const [me, setMe] = useState<Me | null>(null);

  useEffect(() => {
    let active = true;
    void loadMe().then((value) => {
      if (active) setMe(value);
    });
    return () => {
      active = false;
    };
  }, []);

  return me;
}
